module.exports = __webpack_public_path__ + "img/12_11.af673edb.png";